<div class="container cl-form" id="po-form" [formGroup]="poFormGroup">
  @if (airlines().length == 1) {
    <input type="hidden" formControlName="airline" [value]="airlines()[0].iata_code">
  }
  <div class="row">
    @if (airlines().length > 1) {
      <div class="col-12">
        <div class="card cl-tight">
          <div class="card-header">Airline</div>
          <div class="card-body">
            <label for="airlines" class="form-label">Airlines</label>
            <select id="airlines" class="form-select" [class.invalid]="poFormGroup.controls.airline.errors?.required && (poFormGroup.controls.airline.touched || submitted)" formControlName="airline">
              <option [value]="null" disabled selected>[None selected yet]</option>
              @for (airline of airlines(); track airline) {
                <option [value]="airline.iata_code"> {{ airline.airline_name }}
                  ({{ airline.iata_code }})
                </option>
              }
            </select>
            @if (poFormGroup.controls.airline.errors?.required && (poFormGroup.controls.airline.touched || submitted)) {
              <p class="invalid-feedback">This field is required.</p>
            }
            @if (!poFormGroup.controls.airline.errors || (!poFormGroup.controls.airline.touched && !submitted)) {
              <p class="valid-feedback">Specifies the customer for whom this delivery is watermarked.</p>
            }

            <h4>Project information</h4>
            <div class="container">
              <div class="row">
                <div class="col-12">
                  <label for="projectid" class="form-label">Project ID</label>
                  <input id="projectid" [class.invalid]="poFormGroup.controls.po_number.invalid" type="text" formControlName="po_number" pattern="[A-Za-z0-9_\.\-\/]+">
                  @if (poFormGroup.controls.po_number.errors?.required) {
                    <p class="invalid-feedback">This field is
                    required.</p>
                  }
                  @if (poFormGroup.controls.po_number.errors?.pattern) {
                    <p class="invalid-feedback">Only letters, numbers and '_', '-', '/' or '.' are allowed</p>
                  }
                  @if (!poFormGroup.controls.po_number.errors) {
                    <p class="valid-feedback">The Project ID groups related encodes for easier reference and organization.</p>
                  }
                </div>
              </div>
            </div>

            <h4 class="mt-4">Delivery settings</h4>
            <div class="container">
              <div class="row">
                <div class="col-12 col-md-6">
                  <label for="po_destination" class="form-label">Delivery destination<span class="required">*</span></label>
                  <select id="po_destination" class="form-select" [class.invalid]="poFormGroup.controls.po_destination.errors?.required && (poFormGroup.controls.po_destination.touched || submitted)" formControlName="po_destination"
                    [compareWith]="compare_destination_id">
                    <option [value]="null" disabled selected>[None selected yet]</option>
                    @for (sys of poDestinations; track sys) {
                      <option [value]="sys.destination_id">{{ sys.display_name }}</option>
                    }
                  </select>
                  @if (poFormGroup.controls.po_destination.errors?.required && (poFormGroup.controls.po_destination.touched || submitted)) {
                    <p class="invalid-feedback">This field is
                    required.</p>
                  }
                  @if (!poFormGroup.controls.po_destination.errors || (!poFormGroup.controls.po_destination.touched && !submitted)) {
                    <p class="valid-feedback">Select the desired destination.</p>
                  }
                </div>

                <div class="col-12 col-md-6">
                  <label for="auto_publish" class="form-label">Publication</label>
                  <select id="auto_publish" class="form-select" formControlName="auto_publish">
                    <option [ngValue]="true"> Automatic
                    </option>
                    <option [ngValue]="false"> Manual
                    </option>
                  </select>
                  @if (poFormGroup.get('auto_publish')?.value === true) {
                    <p class="valid-feedback">Content is distributed immediately when encoding completes.</p>
                  } @else {
                    <p class="valid-feedback">Content requires QA approval before distribution.</p>
                  }
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    }

  </div>

  <div class="row cl-spacing-small">
    <div class="col-12">
      @if (poItems.controls.length > 0) {
        <h2>PO Items</h2>
        <p>Review the watermark settings for each item below - you can update the Encode ID and the watermark ID that identifies the recipient this copy is traced back to. When ready, press "Start watermarking" to submit.</p>
      }
    </div>
  </div>
  <ng-container formArrayName="poItems">

    @for (item of poItems.controls ; track poItemTrackBy(idx, item); let idx = $index) {
      <ng-container [formGroup]="poItems.controls[idx]" [formGroupName]="idx"
        >
        <div class="row cl-spacing-small" id="po-item-{{idx}}">
          <div class="col-12">
            <h3 [class.invalid]="poItems.controls.length > 1 && poItems.controls[idx].invalid && submitted">
              @if (poItems.controls.length > 1 && poItems.controls[idx].invalid && submitted) {
                <i class="fas fa-exclamation-circle"></i>
              }
              PO item {{ idx + 1 }}: {{ poItems.controls[idx].value['basics']['po_item_id'] }}
              <button class="cl-a-quickaction" (click)="poService.removePOItem(poItems.controls[idx].value['id'])">Remove</button>
            </h3>
          </div>
        </div>
        <input id="idinput" type="hidden" formControlName="id">
        <app-basic-poitem-vod-info formControlName="basics"></app-basic-poitem-vod-info>
        <app-vod-passthrough-format-specific formControlName="format_specific_data"></app-vod-passthrough-format-specific>
        <div class="row">
          <div class="col-12">
            <hr class="cl-spacing-small">
          </div>
        </div>
      </ng-container>
    }


  </ng-container>
  <div class="row">
    <div class="col-12">

      <div class=" cl-spacing-box text-end">
        <app-message-field #messages></app-message-field>
        <app-do-button buttonClass="btn cl-color-primary"  [messageField]="messages" (actionTriggered)="submit_po($event)" >
          <span>Start watermarking{{ poItems.controls.length > 0 ? ' (' + poItems.controls.length + (poItems.controls.length === 1 ? ' item)' : ' items)') : '' }}</span>
        </app-do-button>
      </div>
    </div>
  </div>

</div>
